import { Injectable } from '@angular/core';
import { CustomerSearchPage } from '@asm/const';
import { AsmActions } from '@asm/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED, RouterNavigatedAction } from '@ngrx/router-store';
import { ActivatedRouterStateSnapshot, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { AsmService, CsAgentAuthService } from '../services';

@Injectable()
export class AsmAuthEffects {
  customerAuthorize$: Observable<void> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ROUTER_NAVIGATED),
        take(1),
        map((action: RouterNavigatedAction<ActivatedRouterStateSnapshot>) => action.payload),
        map(
          ({
            routerState: {
              queryParams: { asm, phone },
            },
          }) => ({ asm, phone }),
        ),
        filter(({ asm, phone }) => asm && phone),
        map(({ phone }) => phone.replace(/\D/g, '').slice(-10)),
        filter<string>(Boolean),
        switchMap((phone) =>
          this.csAgentAuthService.isCustomerSupportAgentLoggedIn().pipe(
            tap((isCustomerSupportAgentLoggedIn) => {
              if (isCustomerSupportAgentLoggedIn) {
                if (phone) {
                  this.asmService.customerSearchReset();
                  // запускаем поиск пользователей
                  this.asmService.customerSearch({ query: phone, pageSize: 1 });
                }
              }
            }),
            switchMap(() =>
              this.actions$.pipe(
                ofType(AsmActions.CUSTOMER_SEARCH_SUCCESS),
                map((action: AsmActions.CustomerSearchSuccess) => action.payload),
              ),
            ),
            take(1),
            filter<CustomerSearchPage>(Boolean),
            tap(({ entries }) => {
              if (entries?.length && entries[0].customerId) {
                // Авторизовываем под первым найденым пользователем
                this.csAgentAuthService.startCustomerEmulationSession(entries[0].customerId);
              } else {
                this.messageService.add(
                  `Пользователь с телефоном ${phone} не найден. Авторизация не удалась`,
                  GlobalMessageType.MSG_TYPE_WARNING,
                );
              }
            }),
            map(() => {
              return;
            }),
          ),
        ),
      ),
    { dispatch: false },
  );

  constructor(
    private messageService: GlobalMessageService,
    private actions$: Actions,
    private csAgentAuthService: CsAgentAuthService,
    private asmService: AsmService,
  ) {}
}
